import React from 'react';
import { IconProps } from '.';

const SvgPin = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='m13.766 2.47 7.764 7.764-1.06 1.061-.99-.989-5.621 5.622-.228 3.706a.75.75 0 0 1-1.279.485l-3.705-3.706L3.53 21.53l-1.06-1.06 5.116-5.117-3.705-3.705a.75.75 0 0 1 .485-1.279l3.706-.228 5.622-5.622-.99-.989 1.062-1.06Zm.988 3.11-5.822 5.822a.75.75 0 0 1-.484.219l-2.33.143 6.118 6.117.143-2.329a.75.75 0 0 1 .219-.484l5.822-5.823-3.666-3.665Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgPin;
